import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';
import { getRandomItem } from 'game/helpers/array';

// The priority of the area for card selection:
// 1. hidden cards
// 2. inactive cards

export function findSpiderMagic(game: SolitaireGame) {
    let item = null as MagicItem | null;

    for (let i = 0; i < 3; i++) {
        switch (i) {
            case 0:
                item = checkHint1(game);
                break;
            case 1:
                item = checkHint2(game);
                break;
            case 2:
                item = checkHint3(game);
                break;
        }
        if (item) return item;
    }
    return item;
}

function getCardFromPlace(inactiveCards: Card[], game: SolitaireGame) {
    if (inactiveCards.length === 0) return null;

    const sequences = game.columns.map((column) => column.getLastMoveGroup());
    // sequences.sort((a, b) => b.length - a.length);
    // SW-525 11:01 AM Mar 17
    // We are not looking for the largest sequence. Just take any card.

    const validCardsToMove = [] as {
        priority: number;
        moveCard: Card;
        to: GameBoardPlace;
        place: MagicPlace;
        targetCard: Card | null;
    }[];
    sequences.forEach((s) => {
        if (s.length === 0) return;
        const lastCard = s[s.length - 1];
        const firstCard = s[0];

        for (let index = 0; index < inactiveCards.length; index++) {
            const c = inactiveCards[index];
            if (lastCard.cardColor !== c.cardColor) continue;

            if (lastCard.value - 1 === c.value) {
                validCardsToMove.push({
                    priority: s.length,
                    moveCard: c,
                    to: game.getCardBoardPlace(lastCard),
                    place: MagicPlace.AFTER,
                    targetCard: lastCard,
                });
            }
            if (firstCard.value + 1 === c.value) {
                validCardsToMove.push({
                    priority: s.length,
                    moveCard: c,
                    to: game.getCardBoardPlace(firstCard),
                    place: MagicPlace.BEFORE,
                    targetCard: firstCard,
                });
            }
        }
    });

    if (validCardsToMove.length) {
        const randomMove = getRandomItem(validCardsToMove);
        const { moveCard, to, place, targetCard } = randomMove;
        try {
            if (!moveCard) {
                throw new Error('getCardFromPlace: moveCard is null');
            }
        } catch (error) {
            return null;
        }

        return new MagicItem(moveCard, to, place, targetCard);
    }
    return null;
}
function checkHint1(game: SolitaireGame) {
    // ==== CHECK 1: Tableau (hidden cards). ====
    //Looking for the largest sequence

    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c) => {
            if (!c.visible) hiddenCards.push(c);
        })
    );
    return getCardFromPlace(hiddenCards, game);
}
function checkHint2(game: SolitaireGame) {
    // ==== CHECK 2: Tableau (inactive cards). ====

    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c, i) => {
            if (!c.visible) return;
            if (c.active) return;

            const prevCard = i > 0 ? column.cards[i - 1] : null;
            const nextCard = column.cards[i + 1];
            if (prevCard) {
                if (prevCard.cardColor === c.cardColor && prevCard.canDropInColumn(c)) return;
            }
            if (nextCard && nextCard.cardColor === c.cardColor && c.canDropInColumn(nextCard)) return;

            hiddenCards.push(c);
        })
    );

    return getCardFromPlace(hiddenCards, game);
}
function checkHint3(game: SolitaireGame) {
    // ==== CHECK 2: Tableau (inactive cards). ====
    // any sequence of cards that can be moved to another column

    const validOrderGroups = [[]] as Card[][];
    let currentGroupIndex = 0;

    game.columns.forEach((column) => {
        let lastCard = null as Card | null;

        for (let index = column.length - 1; index >= 0; index--) {
            const card = column.cards[index];
            if (card.active) continue;

            if (column.validOrder(card, lastCard)) {
                validOrderGroups[currentGroupIndex].push(card);
            } else {
                currentGroupIndex++;
                validOrderGroups[currentGroupIndex] = [card] as Card[];
            }
            lastCard = card;
        }
    });
    validOrderGroups.sort((a, b) => a.length - b.length);
    for (let i = 0; i < validOrderGroups.length; i++) {
        const magicMove = getCardFromPlace(validOrderGroups[i], game);
        if (magicMove) return magicMove;
    }
    return null;
}
